var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "payment_guide" } },
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("section", [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: _vm.getImage("top/payment_guide/00_flow.webp")
                    }
                  })
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("1.設置場所のサイズを測る")]),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _c("section", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("①必要な道具を用意する")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage("top/payment_guide/01-01_size.webp")
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(3)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("section", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("②設置場所の空間サイズを測る")]),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage("top/payment_guide/01-02_size.webp")
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(4)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("section", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("③商品サイズを決める")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage("top/payment_guide/01-03_size.webp")
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(5)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("section", { staticClass: "caution_procedure" }, [
                    _c("div", [
                      _c("h3", [_vm._v("家具を壁に固定する場合")]),
                      _vm._v(" "),
                      _c("div", { staticClass: "caution_message" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.getImage(
                              "top/payment_guide/01-04_pillar.webp"
                            )
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(6)
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "detail_btn5 btn_pos_center",
                        on: {
                          click: function($event) {
                            _vm.route("SupportInput")
                          }
                        }
                      },
                      [_vm._v("お問い合わせはこちら 〉〉")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("2.商品をカスタマイズする")]),
                  _vm._v(" "),
                  _vm._m(7),
                  _vm._v(" "),
                  _c("div", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("①お好きな商品を選ぶ")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "top/payment_guide/02-01_customize.webp"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._m(8),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "detail_btn7 btn_pos_left",
                            on: {
                              click: function($event) {
                                _vm.routeCategory()
                              }
                            }
                          },
                          [_vm._v("商品を選ぶ")]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("②商品サイズ、カラーを選択する")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "top/payment_guide/02-02_customize.webp"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(9)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("③組立設置サービスのご選択")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "top/payment_guide/02-03_customize.webp"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(10)
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn5 btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("SupportInput")
                        }
                      }
                    },
                    [_vm._v("お問い合わせはこちら 〉〉")]
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("3.価格を確認しご注文")]),
                  _vm._v(" "),
                  _vm._m(11),
                  _vm._v(" "),
                  _c("div", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("①見積り価格、図面、カラーを確認")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "top/payment_guide/03-01_order.webp"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(12)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("②搬入経路の寸法を確認する")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "top/payment_guide/03-02_order.webp"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(13)
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "procedure" }, [
                    _c("h3", [_vm._v("③ご発注")]),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: {
                          src: _vm.getImage(
                            "top/payment_guide/03-03_order.webp"
                          )
                        }
                      }),
                      _vm._v(" "),
                      _vm._m(14)
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "detail_btn5 btn_pos_center",
                      on: {
                        click: function($event) {
                          _vm.route("Faq")
                        }
                      }
                    },
                    [_vm._v("よくある質問はこちら 〉〉")]
                  )
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("h2", [_vm._v("4.お支払い方法について")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n            お支払い方法は複数あります。"),
                    _c("br"),
                    _vm._v(
                      "\n            ご注文が完了したあとはお支払い方法の変更はできません。"
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(
                      "\n            ※ 個人のお客様がご利用いただける支払い方法は「クレジットカード」、「銀行振込」となります。"
                    ),
                    _c("br"),
                    _vm._v(" "),
                    _vm.isCorpLogin
                      ? _c("span", [
                          _vm._v("※ 法人のお客様は、「"),
                          _c(
                            "span",
                            {
                              staticClass: "link",
                              on: { click: _vm.deferPayment }
                            },
                            [_vm._v("後払いサービス")]
                          ),
                          _vm._v(
                            "」をご利用いただけます。 ＊申込みと審査が必要となります。"
                          )
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                !_vm.isHaseko
                  ? _c("div", [
                      _c("a", { attrs: { href: "tel:0362761123" } }, [
                        _c("img", {
                          attrs: { src: _vm.getImage("bunner/TEL.webp") }
                        })
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "meinmenu_title" }, [
      _c("div", [_vm._v("誰でも簡単オーダー収納家具！")]),
      _vm._v(" "),
      _c("div", [_vm._v("mm/styleご購入ガイド")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "guide_title_msg" }, [
      _vm._v(
        "\n            mm/styleではお客様の用途に応じて、1mm単位でサイズ調整できる収納家具を簡単にオーダーいただけます。"
      ),
      _c("br"),
      _vm._v(
        "\n            お部屋の雰囲気に合わせてカラーもご選択いただけるので、"
      ),
      _c("span", { staticClass: "pickup" }, [
        _vm._v('まさに"あなただけのピッタリ収納"のご注文が可能です。')
      ]),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n            ご購入のご案内として、採寸から商品のカスタマイズ、ご注文までの流れをご説明させていただきます。"
      ),
      _c("br"),
      _vm._v(
        "\n            多くのお客様にとって、家具のオーダは初めてのご経験かと存じます。本ページの説明をご覧いただき、ぜひ、ご自身の暮らしに最適な収納をご購入ください。"
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(
        "\n            生活に寄り添い住空間にフィットする家具のご提供により、お客様の暮らしづくりのお手伝いができれば、大変嬉しく思います。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            オーダー家具のカスタマイズを行う際、最も心配なのはサイズの指定ではないでしょうか。"
      ),
      _c("br"),
      _vm._v(
        "\n            オーダー家具はお客様ひとりひとりのために製造されますので、サイズを間違えて注文された場合の返品や交換はお受けできません。"
      ),
      _c("br"),
      _vm._v(
        "\n            そのようなことがないように、下記をご参考いただき、設置場所の採寸をお願いいたします。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v("\n                  採寸には、メジャーが必須アイテムです。"),
        _c("br"),
        _vm._v(
          "\n                  オススメはステンレス製で幅が太く、ストッパーのついているメジャーです。100円ショップなどでも購入いただけます。"
        ),
        _c("br"),
        _vm._v(
          "\n                  メジャーをたわませず、斜めにならないように測ってください。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                  壁から壁まで、または天井から床まで、ピッタリと収まるサイズでオーダーしたい場合は、設置場所の幅・高さを6箇所ずつ測ってください。"
        ),
        _c("br"),
        _vm._v(
          "\n                  家の壁はまっすぐに見えて、少し歪んでることがほとんどです。傾きを考慮してサイズを決めるため、必ず画像で示している箇所の採寸をお願いします。"
        ),
        _c("br"),
        _vm._v(
          "\n                  なお、床に巾木があったり、壁にコンセントがあったり、天井に廻り縁や火災報知器などの障害物がある場合がございます。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                  計測した実測値の一番小さい値が空間のサイズとなります。"
        ),
        _c("br"),
        _vm._v(
          "\n                  オーダーしたい家具のサイズは、実際に設置したい空間サイズより左右や上下、奥行き方向に10mm程度ずつ隙間ができるようにしてください。"
        ),
        _c("br"),
        _vm._v(
          "\n                  計10mmの隙間であれば、ぴったりと納まっているように見えます（巾木や廻り縁がある場合は、その内側からの寸法となります）。"
        ),
        _c("br"),
        _vm._v(
          "\n                  扉などがある商品の場合、開けたときに他の家具や照明、火災報知器などに当たらないようにサイズを調整してください。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                    吊戸棚（フロート収納）や食器棚（カップボード）等、壁に取り付ける商品の場合、壁面に下地（柱）があるか確認する必要があります。"
        ),
        _c("br"),
        _vm._v(
          "\n                    壁への固定が必要な商品かどうかは、商品詳細ページをご覧ください。"
        ),
        _c("br"),
        _vm._v(
          "\n                    下地材さえうまく見つけることが出来れば、家具の壁止めはどなたでも可能です。"
        ),
        _c("br"),
        _vm._v(
          "\n                    壁をノックして音で確認する方法もありますが、市販の下地探しや下地センサーを活用いただくことで、 より確実に確認することができます。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            採寸して決定した商品サイズを元に、商品のカスタマイズをします。"
      ),
      _c("br"),
      _vm._v(
        "\n            扉やカウンターもそれぞれカラーを選べるので、お部屋の雰囲気に合わせてお好きな組み合わせをお選びください。"
      ),
      _c("br"),
      _vm._v(
        "\n            お客様だけのオーダー家具をプランニングしてください。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n                  用途に応じて、商品カテゴリの中から商品を選択します。"
      ),
      _c("br"),
      _vm._v(
        "\n                  あらかじめ決められたデザインから、設置する場所や収納するものの大きさ、見た目等でお好きな商品をお選びください。"
      ),
      _c("br"),
      _vm._v(
        "\n                  商品はそれぞれ、デザイン、扉の有無、選択できるカラー、材料などが異なります。ご自身のイメージにあったものをお選びください。\n                "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                  商品のカスタマイズ画面にて、ご希望の商品サイズ・カラーを選択しましょう。"
        ),
        _c("br"),
        _vm._v(
          "\n                  商品毎に選択可能な幅・高さ・奥行きサイズが異なりますので、 入力可能な範囲内でのご指定をお願いします。"
        ),
        _c("br"),
        _vm._v("\n                  サイズは1mm単位でご指定いただけます。"),
        _c("br"),
        _vm._v(
          "\n                  配送料金を計算するために、お届け先の郵便番号もご入力ください。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                  組立設置に不安があるお客様は、プロの業者に依頼することもできます。"
        ),
        _c("br"),
        _vm._v(
          "\n                  ご依頼される場合はカスタマイズ画面の「組立設置サービスの選択」にて「あり」をクリックしてください。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "\n            ご選択いただいたサイズ・カラー・配送先情報により、お見積り金額をリアルタイムに計算いたします。"
      ),
      _c("br"),
      _vm._v(
        "\n            金額や商品仕様、搬入経路に問題がなければいよいよご購入です。"
      ),
      _c("br"),
      _vm._v(
        "\n            ご注文に際して、不安やことや気になることがあれば、ページ下部でご紹介しているサポート窓口までお気軽にご連絡ください。\n          "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                  カスタマイズが終了したら、ページ最下部の「図面/見積り」ボタンをクリックしてください。"
        ),
        _c("br"),
        _vm._v(
          "\n                  カスタマイズされた商品の価格・図面が表示されます。"
        ),
        _c("br"),
        _vm._v(
          "\n                  ご確認いただき問題がなければ、「カートに追加」をクリックしてください。商品がカートに追加されます。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                  お届けの際、玄関・室内ドアや階段の幅、マンションのエレベーターの大きさなどが理由で、家具を運べないことがあります。"
        ),
        _c("br"),
        _vm._v(
          "\n                  見積り金額の確認画面に梱包サイズ（お届け時の段ボールサイズ）を表示しておりますので、不安な場所は必ず計測ください。 必要に応じて、商品サイズを小さくするなどの工夫が必要です。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("p", [
        _vm._v(
          "\n                  搬入経路の問題がないことを確認されたら、カート画面の「注文へ進む」ボタンをクリックしてください。"
        ),
        _c("br"),
        _vm._v(
          "\n                  お届け先のご入力や、決済方法のご選択をしてください。"
        ),
        _c("br"),
        _vm._v(
          "\n                  なお、mm/styleの商品は、お客様のオーダーに合わせてひとつひとつ製造する商品なので、キャンセルやご注文後の変更はお受けできません。よくご確認のうえで、ご注文ください。\n                "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b2fc072", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b2fc072","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcPaymentGuide.vue
// module id = null
// module chunks = 